/**
 * Created by moort on 1/11/19.
 */
const avatars = {
    sven: require("./images/sven_eidissen.jpg"),
    danielNew: require("./images/daniel_new.jpg"),
    rajivAmar: require("./images/rajiv_amar.jpg"),
    jaredJones: require("./images/jared_jones.jpg"),
    sahas: require("./images/sahas.jpg"),
    jasonBonifay: require("./images/jason_bonifay.jpg"),
    julianBirkett: require("./images/julian_birkett.jpeg"),
    specialGuest: require("./images/specialGuest.png"),
    carlosOrtiz: require("./images/carlosOrtiz.jpeg"),
    brandonBoyd: require("./images/brandon_boyd.jpeg"),
    kamilRodoper: require("./images/kamil_rodoper.png"),
    vinitMehta: require("./images/vinitMehta.jpeg"),
    abramGoldshtein: require("./images/abramGoldshtein.jpeg")
};

export default avatars;